module.exports = __webpack_public_path__ + "opinion.2ac05739.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/opinion.png
// module id = 351
// module chunks = 0